import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  template: `
    <div class="app-empty-state"  *ngIf="show" fxLayout="column" fxLayoutAlign="center center">
      <div fxFlex="100">
        <div>
        <img src="/assets/Icon-2.png" alt="Empty State Image" style="max-width: 100px; height: auto;">
        </div>
      </div>
      <div fxFlex="100">
        <div class="title">
          {{title}}
        </div>
      </div>
      <div fxFlex="100">
        <div class="sub-title">
          {{subTitle}}
        </div>
      </div>
      <div *ngIf="showAction" fxFlex="100">
        <div class="action">
          <button [color]="actionColor" (click)="actionClick.emit()" mat-raised-button><span class="text-upper">{{actionName}}</span></button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .mat-icon {
        font-size: 64px;
        margin-left: -32px;
        color: lightgray;
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        color: lightgray;
        margin: 16px;
      }

      .sub-title {
        font-size: 16px;
        margin: 8px;
        color: lightgray;
      }

      .action {
        margin: 16px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyStateComponent implements OnInit {
  @Input() show = false;
  @Input() isMobileMode = false;
  @Input() icon = '';
  @Input() title = '';
  @Input() subTitle = '';
  @Input() showAction = false;
  @Input() actionName = '';
  @Input() actionColor = '';
  @Output() actionClick = new EventEmitter();

  constructor() { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() { }
}
